import React, { Component } from 'react';
import Datetime from 'react-datetime'
import '../../../../../node_modules/react-datetime/css/react-datetime.css'
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import Toggle from 'react-toggle';
import { get } from '../../../../server/actions'
import { _addNotification, _addNotificationError, formatDate, showFile, getModuleEnum, getAccessLevelByModule } from "../../../../server/util";
import { date_format } from '../../../../server/constants';
let download = require('downloadjs');
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    snack: 'Snack',
    milk: 'Milk'
}
 const modEnum = getModuleEnum();
class AuditReport extends Component {
    constructor(props) {
        super(props)
       this.state = {
            startDate: moment().startOf('month'),
            endDate: moment(),
            rptMonth: moment(),
            isLunch: true,
            isState: false,

            // MULTI SELECT
            selectedMealTypes: [enumMealType.lunch],

            rptType: 0,
            loading: false,
        };

        this.renderInput = this.renderInput.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
        this.handleMealTypeChange = this.handleMealTypeChange.bind(this);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
   
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    // MULTI SELECT CHECKBOX LOGIC
    handleMealTypeChange = (mealType) => {
        let selectedMealTypes = [...this.state.selectedMealTypes];
              if (selectedMealTypes.includes(mealType)) {
                        selectedMealTypes = selectedMealTypes.filter(type => type !== mealType);
                   } else {
                 selectedMealTypes.push(mealType);
             }
        this.setState({ selectedMealTypes });
    }

     downloadReport = () => {
        const _self = this;
        // VALIDATION
        if ((this.state.selectedMealTypes || []).length === 0) {
            _addNotificationError( 'Please select at least one meal type.',  this);
            return;
        }
        let itemTypes = (this.state.selectedMealTypes || []).join(',');

        if (this.state.rptType === 0) {
            this.setState({ loading: true });
            const start = moment(this.state.startDate).format('YYYY-MM-DDT00:00:00');
            const end = moment(this.state.endDate).format('YYYY-MM-DDT23:59:59');
            let _url = '/reports/generateAuditReport?mealSchoolId=' +sessionStorage.getItem('SchoolId') +'&startDate=' +moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +'&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                   '&itemType=' + itemTypes +'&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&isState=' +this.state.isState + '&access_token=';
            get(_url)
                .then((response) => {
                    if (!response.ok) {
                        if (
                            response.status === 417 || response.status === 422
                        ) {
                            return response.json();
                        }
                    }
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        throw Error(res.statusMessage);
                    } else if (res.statusCode === 422) {
                        throw Error(res.statusMessage);
                    } else {
                        return res.blob();
                    }
                }).then(blob => {
                    let filename = "Summarized reimbursement claim report";
                    showFile(blob, filename);
                    this.setState({ loading: false });
                }).catch((error) => {
                    let msg = '';
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self);
                    this.setState({ loading: false });
                });
        } else {
            this.setState({ loading: true });
            const start = moment(this.state.rptMonth.startOf('month')).format('YYYY-MM-DDT00:00:00');
            const end = moment(this.state.rptMonth.endOf("month")).format('YYYY-MM-DDT23:59:59');
            let _url = '/reports/auditDailyEditCheck?mealSchoolId=' + sessionStorage.getItem('SchoolId') +'&startDate=' +moment(start, 'YYYY-MM-DDTHH:mm:ss')
                    .utc() .format("YYYY-MM-DDTHH:mm:ss") +'&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                    '&yearMonth=' +this.state.rptMonth.format('YYYYMM') +'&itemType=' + itemTypes + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
                    '&isState=' +this.state.isState + '&access_token=';
            get(_url)
                .then((response) => {
                    if (!response.ok) {
                        if (
                            response.status === 417 || response.status === 422
                        ) {
                            return response.json();
                        }
                    }
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        throw Error(res.errorMessage);
                    } else if (res.statusCode === 422) {
                        throw Error(res.statusMessage);
                    } else {
                        return res.blob();
                    }
                }).then(blob => {
                    let filename = "DailyEditCheckReport";
                    showFile(blob, filename);
                    this.setState({ loading: false });
                }).catch((error) => {
                    let msg = '';
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self);
                    this.setState({ loading: false });
                });
        }
    }

    render() {
        const _loggedInUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        return (
            <div className="row">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                 <div className="col-md-offset-3 col-md-6">
                     <div className="panel panel-primary">
                         <div className="panel-body">
                             <div className="row">
                                 <div className="uploadFileInfo col-md-12 createmenu-month-group form-group" >
                                     <div className='row'>
                                         <label className="custom-label col-md-4 text-left" style={{ margin: '18px 0px' }}>Report Type</label>
                                         <div className="styled-input-single col-md-4 ">
                                             <input type="radio" name="isState" id={'rb-isState1'} onChange={(e) => {
                                                if (e.target.checked) {
                                                    this.setState({ isState: false });
                                                }

                                            }} checked={this.state.isState === false} />
                                            <label htmlFor={'rb-isState1'}>Federal</label>
                                        </div>
                                        {_loggedInUserInfo.stateIncomeEligEnabled == true ? <div className="styled-input-single col-md-4">
                                            <input type="radio" name="isState" id={'rb-isState2'} onChange={(e) => {
                                                if (e.target.checked) {
                                                    this.setState({ isState: true });
                                                }
                                            }} checked={this.state.isState === true} />
                                            <label htmlFor={'rb-isState2'}>State</label>
                                        </div> : null}
                                    </div>
                                </div>
                              {/* REPORT FOR */}

                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <div className="row">
                                     <label className="custom-label col-md-4 text-left" style={{ margin: '10px 0px' }}>
                                        Report for
                                    </label>
                                    <div className="col-md-8 col-sm-12 col-xs-12" style={{ marginBottom: '11%', marginLeft:'-13px' }}>
                                        <div className="row">
                                            {
                                                (getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCI)) ?
                                                    <div className="col-md-3 col-sm-6 col-xs-6">
                                                        <div className="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked={this.state.selectedMealTypes.includes(enumMealType.lunch) }
                                                                    onChange={() => this.handleMealTypeChange( enumMealType.lunch )
                                                                    }
                                                                />
                                                                {' '}
                                                                {enumMealType.lunch}
                                                            </label>
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                (getAccessLevelByModule(modEnum.BMCU) || getAccessLevelByModule(modEnum.BMCI)) ?
                                                    <div className="col-md-3 col-sm-6 col-xs-6">
                                                        <div className="checkbox">
                                                            <label>
                                                                <input type="checkbox" checked={ this.state.selectedMealTypes.includes(enumMealType.breakfast) }
                                                                    onChange={() => this.handleMealTypeChange( enumMealType.breakfast  )
                                                                    }
                                                                />
                                                                {' '}
                                                                {enumMealType.breakfast}
                                                            </label>
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                (getAccessLevelByModule(modEnum.SMCU) || getAccessLevelByModule(modEnum.SMCI)) ?
                                                    <div className="col-md-3 col-sm-6 col-xs-6" style={{ marginLeft: '12px' }}>
                                                        <div className="checkbox">
                                                            <label>
                                                                <input type="checkbox"
                                                                       checked={ this.state.selectedMealTypes.includes(enumMealType.snack) }
                                                                       onChange={() => this.handleMealTypeChange( enumMealType.snack )
                                                                    }
                                                                />
                                                                {' '}
                                                                {enumMealType.snack}
                                                            </label>
                                                        </div>
                                                    </div> : null
                                            }
                                            <div className="col-md-3 col-sm-6 col-xs-6" style={{ marginLeft: '-12px' }}>
                                                <div className="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               checked={ this.state.selectedMealTypes.includes(enumMealType.milk)}
                                                               onChange={() => this.handleMealTypeChange( enumMealType.milk )
                                                            }
                                                        />
                                                        {' '}
                                                        {enumMealType.milk}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                             </div>   
                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                     <div className="styled-input-single col-md-12" style={{ margin: '-45px 15px' }}>
                                         <input type="radio" name="rdRpt" id="rdSummaryRpt" onChange={() => {
                                            this.setState({ rptType: 0 })
                                        }} checked={this.state.rptType === 0} />
                                        <label htmlFor='rdSummaryRpt'>{'Summarized reimbursement claim report'}</label>
                                    </div>
                                    <div className="styled-input-single col-md-12" style={{ margin: '-11px 15px' }}>
                                        <input type="radio" name="rdRpt" id="rdDailyEditRpt" onChange={() => {
                                            this.setState({ rptType: 1 })
                                        }} checked={this.state.rptType === 1} />
                                        <label htmlFor='rdDailyEditRpt'>{'Daily edit check worksheet report'}</label>
                                    </div>
                                </div>
                                {
                                    this.state.rptType === 0 ?
                                        <div>
                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Start Date</label>
                                                <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                    <Datetime ref='startCalendar' dateFormat={date_format()} timeFormat={false}
                                                        closeOnSelect={true} value={this.state.startDate}
                                                        onChange={(e) => {
                                                            this.setState({ startDate: moment(e) })
                                                            this.refs.endCalendar.closeCalendar()
                                                        }} renderInput={this.renderInput} />
                                                </div>
                                            </div>
                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>End Date</label>
                                                <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                    <Datetime ref='endCalendar' dateFormat={date_format()} timeFormat={false}
                                                        closeOnSelect={true} value={this.state.endDate}
                                                        onChange={(e) => {
                                                            this.setState({ endDate: moment(e) })
                                                            this.refs.endCalendar.closeCalendar()
                                                        }} renderInput={this.renderInput} />
                                                </div>
                                            </div>
                                        </div> :
                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                            <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Select Month</label>
                                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                <Datetime ref='calendar' dateFormat="MMM-YYYY" timeFormat={false}
                                                    closeOnSelect={true} value={moment(this.state.rptMonth)}
                                                    onChange={(e) => {
                                                        this.setState({ rptMonth: moment(e) })
                                                        this.refs.calendar.closeCalendar()
                                                    }} renderInput={this.renderInput} />
                                            </div>
                                        </div>
                                }

                                <div className="row">
                                    <div className="col-md-12">
                                        <button className="btn btn-success btn-sm pull-right" onClick={(e) => {
                                            e.preventDefault();
                                            this.downloadReport();
                                        }}> Download Report
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AuditReport


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/auditReportComponents/auditReport.jsx